import { dateStringToDate } from '.';
import { format, today, yesterday, isAfter, isBefore, isSameMonth, addMonths, subDays, subMonths } from '../../../utils/date';

export const initialFrom = (dateFrom, currentPeriod, maxDate) => {
  if (dateFrom) return dateStringToDate(dateFrom);
  return dateStringToDate(subDays(maxDate, currentPeriod - 1));
};

export const initialTo = (dateTo, maxDate) => {
  const effectiveDate = dateStringToDate(dateTo || yesterday());

  if (!maxDate) { return effectiveDate; }

  return effectiveDate > maxDate ? maxDate : effectiveDate;
};

export const initialToMonth = (fromDate, toDate, maxPeriod) => {
  const minDate = subDays(toDate, maxPeriod - 1);
  if (isSameMonth(fromDate, toDate) && isSameMonth(minDate, toDate) && !isSameMonth(yesterday(), toDate)) {
    return dateStringToDate(addMonths(toDate, 1));
  }

  return toDate;
};

export const getFromMonth = (fromDate, toDate, maxPeriod) => {
  if (isSameMonth(fromDate, toDate)) {
    const minDate = subDays(today(), maxPeriod - 1);
    const nextFromMonth = subMonths(fromDate, 1);
    if (!isBefore(nextFromMonth, minDate)) {
      return dateStringToDate(nextFromMonth);
    }
  }

  return fromDate;
};

const getToMonth = (fromDate, toDate) => {
  if (isSameMonth(fromDate, toDate)) {
    const maxDate = yesterday();
    const nextToMonth = addMonths(toDate, 1);
    if (!isAfter(nextToMonth, maxDate)) {
      return dateStringToDate(nextToMonth);
    }
  }

  return toDate;
};

export const getRangeMonths = (range, prevRange, maxPeriod, type) => {
  const { monthFrom: prevFrom, monthTo: prevTo } = prevRange;

  let nextFrom = range.from;
  if (!range.from) nextFrom = prevFrom || dateStringToDate(yesterday());

  let nextTo = range.to;
  if (!range.to) nextTo = prevTo || dateStringToDate(yesterday());

  if (type === 'to') {
    return {
      monthFrom: getFromMonth(nextFrom, nextTo, maxPeriod),
      monthTo: nextTo,
    };
  }

  return {
    monthFrom: nextFrom,
    monthTo: getToMonth(nextFrom, nextTo, maxPeriod),
  };
};

export const maskedValue = (value = '') => {
  const splitedValue = value.split('/');
  const hasTwoDividers = splitedValue.length === 3;

  if (hasTwoDividers) return value;

  const preparedValue = splitedValue.join('');
  const mm = preparedValue.slice(0, 2);
  const dd = preparedValue.slice(2, 4);
  const yyyy = preparedValue.slice(4);
  const mmFormatted = mm.length === 2 ? `${mm}/` : mm;
  const ddFormatted = dd.length === 2 ? `${dd}/` : dd;

  return `${mmFormatted}${ddFormatted}${yyyy}`;
};

export const initialLastAllowedDate = (dateTo, maxDate) => {
  const effectiveDate = format(dateTo || yesterday());
  const formattedMaxDate = format(maxDate);

  if (!maxDate) { return effectiveDate; }

  return isBefore(effectiveDate, formattedMaxDate) ? effectiveDate : formattedMaxDate;
};
